const ShipyardVisitsMapLegend = () => {
	return (
		<div className="flex space-x-2 text-sm">
			<div className="flex items-center space-x-2">
				<span className="w-3 h-3 bg-msi-port-calls-in-shipyard rounded-full"></span>
				<span>In Shipyard</span>
			</div>
		</div>
	);
};

export default ShipyardVisitsMapLegend;
